import { Page } from '@/core/architecture'

import { StoreItemPurchaseProceedTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * StoreItem Page
 * Implemented as a practical sample.
 */
export const StoreItemPurchaseProceed: Page = () => {
  const { state, actions } = useViewModel()

  return <StoreItemPurchaseProceedTemplate state={state} {...actions} />
}
